// These colorSets are to be used inside the pinRenderer instead of the one from ui-components
export const colorSets = {
  disabled: {
    strokeSubjacent: '#C2C7D6',
  },
  active: {
    on: '#4E7FFF',
  },
};
